import type { ReactNode } from "react";

/**
 * CinematicRouteFrame · wraps the app's <Routes> as the stable page
 * frame for cinematic navigations.
 *
 * Dead-code hygiene (2026-05-18): this frame's ONLY active behavior was
 * the per-frame page transform driven by `globeDiveController`'s `w`
 * during a `globe-dive` (the landing-CTA dolly). Landing CTAs are now
 * plain instant navigation (shipped 065c935b) so the dolly was removed,
 * and the controller-driven branch here was genuinely dead — for every
 * NON-landing transition this frame was already a pure pass-through
 * (`phase` never left "idle"), so removing the dead branch is behavior-
 * preserving for non-landing routes.
 *
 * Kept as the wrapping component (unchanged `App.tsx` structure) so the
 * non-landing transition contract and the route tree's mount point are
 * untouched.
 */
export function CinematicRouteFrame({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
